export default function geocodeSinglePosition(ymaps, coords) {
  return new Promise((resolve, reject) => ymaps.geocode(coords, { results: 1, json: true })
    .then((res) => resolve(res.GeoObjectCollection))
    .catch(reject));
}
